// scrollToTop.ts
export function scrollToTop(
  selector: string = "#main-section-container", // default is ID
  behavior: ScrollBehavior = "smooth"
) {
  let container: Element | null = null;

  if (selector.startsWith("#")) {
    container = document.getElementById(selector.slice(1));
  } else if (selector.startsWith(".")) {
    container = document.querySelector(selector);
  } else {
    // fallback if no prefix provided
    container = document.querySelector(selector);
  }

  if (container) {
    (container as HTMLElement).scrollTo({top: 0, behavior});
  } else {
    window.scrollTo({top: 0, behavior});
  }
}
